export default __webpack_public_path__ + "static/media/delivery.8130a9f7.jpg";